<!-- 处理工作台页面 -->
<template>
    <div class="dealer-list-container">
        <div class="tabs">
            <div class="tab" :class="active == 1 ? 'active' : ''" @click="getlist(1)">
                <p>待处理</p>
                <p class="line"></p>
            </div>
            <div class="tab" :class="active == 2 ? 'active' : ''" @click="getlist(2)">
                <p>已处理</p>
                <p class="line"></p>
            </div>
        </div>
        <div class="list">
            <van-list
                v-if="dealerBindLoading"
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="getlist"
            >
                <div class="item" @click="toDetail(item)" v-for="item in list" :key="item">
                    <div class="item-all">
                        <div class="item-l">
                            <p class="title">{{ item.goodsModelNo }}</p>
                            <p class="phone">{{ item.applyMobileMask }}</p>
                        </div>
                        <div class="item-r">
                            <p class="price">¥{{ item.goodsPrice }}元</p>
                        </div>
                    </div>
                    <div class="item-all">
                        <div class="item-l">
                            <p class="time">申请时间: {{ item.updateTime }}</p>
                        </div>
                        <div class="item-r">
                            <p class="reason" v-show="active == 2" :style="{color: item.status == '2' || item.status == '4' ? '#51BB3D' : '#F60628'}">{{ item.status == '3' ? '已拒绝': item.status == '2' || item.status == '4' ? '已同意' : ''}}</p>
                        </div>
                    </div>

                    
                </div>
            </van-list>
        </div>
    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import { Button, List } from 'vant'
  import { dealerBindApi, dealerBindListApi } from '@/apis/kdb'
  Vue.use(Button).use(List)
  export default {
    data() {
      return {
        active: 1,
        list: [
            // {
            //     goodsModelNo: "JMYD111341D",
            //     applyMobileMask: '185****1036',
            //     updateTime: '2024-10-29 14:33:28',
            //     goodsPrice: '5200.00',
            //     status: '2',
            // }
        ],
        loading: false,
        finished: false,
        page: {
            statusArr: ['1'],
            pageNum: 1,
            pageSize: 10
        },
        type: 1,
        dealerBindLoading: false
      }
    },
    async created() {
        this.dealerBindFun()
    },
    methods: {
        toDetail(item){
            this.$router.push({
                path: '/dealerDetail',
                query: {
                    id: item.id,
                },
            })
        },
        async getlist(type = 1){
            if(type != this.type) {
                this.active = this.type = type
                this.list = []
                this.page = {
                    statusArr: type == 1 ? ['1']: ['2', '3', '4'],
                    pageNum: 1,
                    pageSize: 10
                }
            }
            try {
                const res =  await dealerBindListApi(this.page)
                this.list.push(...res.data.rows)
                // 加载状态结束
                this.loading = false;

                // // 数据全部加载完成
                if (this.list.length >= res.data.total) {
                    this.finished = true;
                }else{
                    this.page.pageNum++
                }
            } catch (error) {
                console.log(1);
            }
        },
        async dealerBindFun(){
            let { id } = this.$route.query
            try {
                const res =  await dealerBindApi({
                    id,
                    status: '1'
                })
                this.dealerBindLoading = true
            } catch (error) {
                
            }
        },
    },
  }
  </script>
  
  <style lang="less" scoped>
  .dealer-list-container {
    padding: 0.42rem 0.42rem /* 21/50 */;
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    position: relative;
    .tabs {
        display: flex;
        .tab {
            font-weight: 400;
            font-size: 0.36rem;
            color: #969797;
            line-height: 0.52rem;
            text-align: left;
            font-style: normal;
            margin-right: 0.52rem;
            position: relative;
        }
        .active {
            color: #333333;
            font-weight: 500;
        }
        .active:after {
            content: '';
            position: absolute;
            bottom: -0.1rem;
            left: 0.2rem;
            width: 0.5rem;
            height: 0.1rem;
            background: #FF5E00;
            z-index: 1;
            transform: translateX(0.08rem);
            background: #3C7CFF;
            border-radius: 0.05rem;
        }
    }

    .list {
        margin-top: 0.70rem;
        box-sizing: border-box;
        padding-bottom: 1rem;
        .item {
            background: #FFFFFF;
            box-shadow: 0rem 0rem 0.06rem 0rem rgba(194,194,194,0.5);
            border-radius: 0.18rem;
            padding: 0.2rem 0.3rem;
            margin-bottom: 0.26rem;
            .item-all {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                .item-l {
                    .title {
                        color: #333333;
                        font-weight: 500;
                        font-size: 0.32rem;
                        line-height: 0.48rem;
                    }
                    .phone {
                        font-weight: 400;
                        font-size: 0.28rem;
                        color: #AEB0B1;
                        line-height: 0.4rem;
                    }
                    .time {
                        margin-top: 0.1rem;
                        font-weight: 400;
                        font-size: 0.28rem;
                        color: #AEB0B1;
                        line-height: 0.4rem;
                    }
                }
                .item-r {
                    display: flex;
                    flex-direction: column;
                    .price {
                        font-weight: bold;
                        font-size: 0.32rem;
                        line-height: 0.48rem;
                        color: #F60628;
                    }
                    .reason {
                        font-size: 0.28rem;
                        font-weight: bold;
                        text-align: end;
                        margin-top: 0.5rem;
                    }
                }
            }
            
        }
        
    }

  }
  </style>
  